import { ButtonLink, Container, Heading, Lead } from '../components/ui';
import { usePageTitle } from '../lib/usePageTitle';

export function NotFound() {
  usePageTitle('Page not found — WaveQA');

  return (
    <Container className="flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
      <p className="font-mono text-sm text-surge-400">404</p>
      <Heading level={1} className="mt-3 text-white">
        We could not find that page
      </Heading>
      <Lead className="mt-4 max-w-md">
        The link may be out of date, or the page may have moved.
      </Lead>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <ButtonLink to="/">Back to home</ButtonLink>
        <ButtonLink to="/docs" variant="secondary">
          Documentation
        </ButtonLink>
      </div>
    </Container>
  );
}
